import { cookieDomain } from "../lib/api-core";
import { cookiesNameStatic } from "../common/statics/cookiesNameStatic";

export function clearAllAuthData() {
  // Clear all cookies
  const cookiesToClear = [
    cookiesNameStatic.IS_AUTHENTICATED,
    cookiesNameStatic.ACCESS_TOKEN,
    cookiesNameStatic.CHECK_3PARTY_AVAILAPILITY,
    cookiesNameStatic.USER_IDENTIFIER,
  ];

  cookiesToClear.forEach((cookieName) => {
    // Clear with domain
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${cookieDomain}; SameSite=None; Secure`;
    // Clear without domain (fallback)
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure`;
  });

  // Clear session storage but preserve the 401 redirect guard
  const redirectingKey = sessionStorage.getItem("__zn_401_redirecting");
  sessionStorage.clear();
  if (redirectingKey) sessionStorage.setItem("__zn_401_redirecting", redirectingKey);

  // Clear specific localStorage items (keep language preference)
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key !== "gatsby-i18next-language") {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key));
}

export function performLogout(redirectPath = "/auth/login") {
  clearAllAuthData();
  window.location.replace(redirectPath);
}
